import { X } from "react-feather";
import { useMapStore } from "../../../store/mapStore";
import { getAirspaceDroneDetails } from "../../../api/dronesAPI";
import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../../../store/authStore";
import { useEffect, useState } from "react";
import useDroneStore from "../../../store/droneStore";
import moment from "moment";

const AirspaceDroneInfo = ({ currentPosition, droneCategory, droneId, droneName, uin, currentMission, updatedOn }) => {
    const [imageData, setImageData] = useState('');
    const { setShowAirspaceDroneInfo } = useMapStore((state) => state)
    const { setDroneImgToView } = useDroneStore((state) => state)
    const { token, setLoaderState } = useAuthStore((state) => state)
    const { isLoading, data, error } = useQuery({
        queryFn: getAirspaceDroneDetails,
        queryKey: ["getAirspaceSingleDrones", token, droneId],
        refetchOnWindowFocus: false,
    });
    useEffect(() => {
        if (data?.data?.data) {
            // console.log(data?.data?.data?.img)
            setImageData(data?.data?.data?.img);
        }
    }, [data?.data?.data])
    return (
        <div key={droneId} className="bg-slate-100 z-[1000] p-4 right-28 rounded-xl top-4 w-fit h-fit absolute">
            <div className="flex justify-between">
                <div>
                    <h1 className="text-xl font-semibold capitalize">{droneName}</h1>
                </div>
                <div>
                    <span className="cursor-pointer" onClick={() => setShowAirspaceDroneInfo(false)}><X /></span>
                </div>
            </div>
            <div className="mt-5">
                <div className="grid grid-cols-2">
                    <div className="p-2 rounded-xl bg-white mr-4 text-start">
                        <div className="font-semibold text-tblu">Category</div>
                        <div className="capitalize text-lg">{droneCategory}</div>
                    </div>
                    <div className="p-2 rounded-xl bg-white mr-4 text-start">
                        <div className="font-semibold text-tblu">UIN</div>
                        <div className="capitalize text-lg break-all">{uin}</div>
                    </div>
                </div>
                <div className="p-2 rounded-xl mt-5 bg-white mr-4 text-start">
                    <div className="font-semibold text-tblu">Current Position</div>
                    <div className="capitalize text-lg">{currentPosition}</div>
                </div>
                {currentMission && <div className="p-2 rounded-xl mt-5 bg-white mr-4 text-start">
                    <div className="font-semibold text-tblu">Current Mission</div>
                    <div className="capitalize text-lg">{currentMission}</div>
                </div>}
                <div className="p-2 rounded-xl mt-5 bg-white mr-4 text-start">
                    <div className="font-semibold text-tblu">Last Updated On</div>
                    <div className="capitalize text-lg">{moment(updatedOn).format("DD-MM-YYYY hh:mm:ss A")}</div>
                </div>
                {imageData?.length > 0 && <div className="p-2 rounded-xl mt-5 bg-white mr-4 text-start">
                    <div className="font-semibold text-tblu">Drone Images</div>
                    <div className="grid grid-cols-2 z-[99999999] relative">
                        {
                            imageData.length > 0 && imageData.map((img, index) => {
                                return (
                                    <>
                                        <div className="mt-10" key={index}>
                                            <img src={img} key={index} onClick={() => { setDroneImgToView(img) }} className="h-20" alt="" />
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>}
            </div>
        </div>
    )
};

export default AirspaceDroneInfo;